import React from 'react';
import FormDialogRenderer from './CustomFormDialogRenderer';
import i18n from 'i18n';
import {
  DialogBody as WrappingTypeDialogBody,
  DialogFooter as WrappingTypeDialogFooter
} from './WrappingTypeDialogCompoents';
import {
  DialogBody as InscriptionDialogBody,
  DialogFooter as InscriptionDialogFooter
} from './InscriptionDialogComponents';

class WrappingInfoDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dialogType: 'wrappingType'
    };
  }

  handleClickNext = () => {
    this.setState({
      dialogType: 'inscription'
    });
  };

  handleClickBack = () => {
    this.setState({
      dialogType: 'wrappingType'
    });
  };

  getDialogTitle() {
    switch (this.state.dialogType) {
      case 'wrappingType':
        return i18n.t('orderAggregators:common:order.wrappingTypeDialogTitle');

      case 'inscription':
        return i18n.t('orderAggregators:common:order.inscriptionDialogTitle');

      default:
        break;
    }
  }

  getDialogBody(props) {
    switch (this.state.dialogType) {
      case 'wrappingType':
        return <WrappingTypeDialogBody {...props} />;

      case 'inscription':
        return <InscriptionDialogBody {...props} />;

      default:
        return null;
    }
  }

  getDialogFooter(props) {
    switch (this.state.dialogType) {
      case 'wrappingType':
        return <WrappingTypeDialogFooter {...props} />;

      case 'inscription':
        return <InscriptionDialogFooter {...props} />;

      default:
        return null;
    }
  }

  handleSubmit = event => {
    this.handleClose();

    this.props.onSubmit(event);
  };

  handleClose = event => {
    this.setState({
      dialogType: 'wrappingType'
    });
  };

  render() {
    const { className, dialogRef, initialValues } = this.props;

    return (
      <div className={className}>
        <FormDialogRenderer
          title={this.getDialogTitle()}
          innerRef={dialogRef}
          renderBody={props =>
            this.getDialogBody({
              ...props
            })
          }
          renderFooter={props =>
            this.getDialogFooter({
              onClickNext: this.handleClickNext,
              onClickBack: this.handleClickBack,
              ...props
            })
          }
          initialValues={initialValues}
          onSubmit={this.handleSubmit}
          onClose={this.handleClose}
          showCloseAlert={true}
        />
      </div>
    );
  }
}

export default WrappingInfoDialog;



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/components/WrappingInfoDialog.js